import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import {
  MeasurementMap,
  MeasurementMapQuery,
  MeasurementMapQueryVariables,
} from '../../../../data-access/gql-types/graphql';
import { MEASUREMENT_MAP } from '../../../../data-access/queries/meter';
import { useCacheStore } from '../../store/cache';
import { useMeasurementMapStore } from '../../store/measurement-map';

export const useFetchMeasurementMap = () => {
  const { skipLavvaFetch } = useInstallationContext();
  const setMeasurementMap = useMeasurementMapStore((s) => s.setMeasurementMap);
  const measurementMapSkip = useCacheStore((s) => s.measurementMapSkip);
  const measurementMapData = useQuery<MeasurementMapQuery, MeasurementMapQueryVariables>(MEASUREMENT_MAP, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    skip: skipLavvaFetch || measurementMapSkip,
  });

  useEffect(() => {
    if (measurementMapData.data) setMeasurementMap(measurementMapData.data.measurementMap as MeasurementMap, true);
  }, [measurementMapData]);
};
